<template>
  <div class="content__body" ref="scrollContent">
    <ui-loading-circle v-if="isLoading" />
    <div v-else>
      <template v-if="canDeactivate">
        <template v-if="unusedJam === 'deactivated'">
            <content-box class="content__withdraw can-deactivate" :width="'800px'">
              <div class="title--wrap">
                <p class="title" v-html="$t('userInfo.myInformation.deactivateInfo.header.title')"></p>
              </div>
              <div class="analytics-page--wrap center">
                <div class="unused-jam--wrap">
                  <div class="description" v-html="$t('plan.jam.DeactivationJam')"></div>
                  <div class="jam-info">
                    <div class="jam">
                      <div class="icon icon--small-jam"></div>
                      <span>{{ $t('plan.jam.myJam') }}</span>
                    </div>
                    <div class="count">{{ jam.total | thousand }} <span>{{ $t('plan.jam.jamAmount') }}</span></div>
                  </div>
                </div>
              </div>
            </content-box>
            <div class="button--wrap">
              <ui-button class="btn__cancel"
                         @click="onCancelDeactivate">{{ $t('common.cancel') }}</ui-button>
              <ui-button :primary="true"
                         @click="onMoveContactUs">{{ $t('common.contactUs') }}</ui-button>
            </div>
            <back-to-top :refName="'scrollContent'" />
          </template>
        <template v-else>
          <content-box class="content__withdraw can-deactivate" :width="'800px'">
            <div class="title--wrap">
              <p class="title" v-html="$t('userInfo.myInformation.deactivateInfo.header.title')"></p>
              <i class="icon icon--logo-only-ba"></i>
              <i class="icon icon--logo-only-beu"></i>
              <i class="icon icon--logo-only-geo"></i>
              <br><strong v-html="$t('userInfo.myInformation.deactivateInfo.header.desc')"></strong>
            </div>
            <div class="desc--wrap">
              <p v-html="$t('userInfo.myInformation.deactivateInfo.can.desc1')"></p>
              <p v-html="$t('userInfo.myInformation.deactivateInfo.can.desc2')"></p>
            </div>
            <div class="analytics-page--wrap">
              <ul>
                <li>
                  <h5 v-html="$t('userInfo.myInformation.deactivateInfo.can.analyticsPage.title.info')"></h5>
                  <p v-html="$t('userInfo.myInformation.deactivateInfo.can.analyticsPage.info')"></p>
                </li>
                <li v-if="isUsingService.beusable">
                  <h5 v-html="$t('userInfo.myInformation.deactivateInfo.can.analyticsPage.title.page')"></h5>
                  <p v-html="$t(`userInfo.myInformation.deactivateInfo.can.analyticsPage.beusable.${deactivateInfo.beusable_page_count > 1 ? 'plural' : 'singular'}`, { beusablePageCount: deactivateInfo.beusable_page_count })"></p>
                </li>
                <li v-if="isUsingService.ba">
                  <h5 v-html="$t('userInfo.myInformation.deactivateInfo.can.analyticsPage.title.domain')"></h5>
                  <p v-html="$t(`userInfo.myInformation.deactivateInfo.can.analyticsPage.ba.${deactivateInfo.ba_domain_count > 1 ? 'plural' : 'singular'}`, { baDomainCount: deactivateInfo.ba_domain_count })"></p>
                </li>
              </ul>
            </div>
            <div class="chk-box--wrap">
              <ui-checkbox :value="model.withDrawAgree"
                           @input="onChangeCheckboxValue">
                {{ $t('userInfo.myInformation.deactivateInfo.can.analyticsPage.checkbox') }}
              </ui-checkbox>
              <strong v-if="modelError" class="validation-text">{{ $t('common.validationErrorText.deactivateConfirm') }}</strong>
            </div>
          </content-box>
          <div class="button--wrap">
            <ui-button class="btn__cancel"
                       @click="onCancelDeactivate">{{ $t('common.cancel') }}</ui-button>
            <ui-button :primary="true"
                       :disabled="!model.withDrawAgree"
                       @click="onShowConfirmDeleteLayer">{{ $t('common.confirm') }}</ui-button>
          </div>
          <back-to-top :refName="'scrollContent'" />
        </template>
      </template>

      <template v-else>
        <content-box class="content__withdraw no-deactivate" :width="'800px'">
          <div class="title--wrap">
            <p class="title" v-html="$t('userInfo.myInformation.deactivateInfo.header.title')"></p>
          </div>
          <div class="current-plan--wrap">
            <p class="desc" v-html="$t('userInfo.myInformation.deactivateInfo.canNot.currentPlan.desc')"></p>
            <div>
              <ul>
                <li v-if="isUsingService.beusable">
                  <i class="icon icon--logo-only-beu"></i>
                  <span class="plan-name">{{ beusablePlan.current.planName }}</span>
                  <span v-if="canDeactivateService.beusable"
                        class="expire-date"
                        v-html="$t('userInfo.myInformation.deactivateInfo.canNot.withdrawalPlan')"></span>
                  <span v-else-if="beusablePlan.current.paymentMethod === 'wire transfer' || beusablePlan.current.coupon || !beusablePlan.current.paymentMethod || ['admin', '4grit'].includes(beusablePlan.current.paymentMethod)"
                        class="expire-date"
                        v-html="$t('userInfo.myInformation.deactivateInfo.canNot.currentPlan.expireDate', { endDate: formatEndDate(beusablePlan.current.useEndDate) })"></span>
                  <div v-else class="cancel-subscription">
                    <ui-button :iconName="'icon--link-size16'"
                               @click="onMoveCancelSubscription('beusable')">{{ $t('common.cancelSubscription') }}</ui-button>
                  </div>
                </li>
                <li v-if="isUsingService.ba">
                  <i class="icon icon--logo-only-ba"></i>
                  <span class="plan-name">{{ baPlan.current.planName }}</span>
                  <span v-if="canDeactivateService.ba"
                        class="expire-date"
                        v-html="$t('userInfo.myInformation.deactivateInfo.canNot.withdrawalPlan')"></span>
                  <span v-else-if="baPlan.current.paymentMethod === 'wire transfer' || baPlan.current.coupon || !baPlan.current.paymentMethod || ['admin', '4grit'].includes(baPlan.current.paymentMethod)"
                        class="expire-date"
                        v-html="$t('userInfo.myInformation.deactivateInfo.canNot.currentPlan.expireDate', { endDate: formatEndDate(baPlan.current.useEndDate) })"></span>
                  <div v-else class="cancel-subscription">
                    <ui-button :iconName="'icon--link-size16'"
                               @click="onMoveCancelSubscription('ba')">{{ $t('common.cancelSubscription') }}</ui-button>
                  </div>
                </li>
                <li v-if="isUsingService.geo">
                  <i class="icon icon--logo-only-geo"></i>
                  <span class="plan-name">{{ geoPlan.current.planName }}</span>
                  <span v-if="canDeactivateService.geo"
                        class="expire-date"
                        v-html="$t('userInfo.myInformation.deactivateInfo.canNot.withdrawalPlan')"></span>
                  <span v-else-if="geoPlan.current.paymentMethod === 'wire transfer' || geoPlan.current.coupon || !geoPlan.current.paymentMethod || ['admin', '4grit'].includes(geoPlan.current.paymentMethod)"
                        class="expire-date"
                        v-html="$t('userInfo.myInformation.deactivateInfo.canNot.currentPlan.expireDate', { endDate: formatEndDate(geoPlan.current.useEndDate) })"></span>
                  <div v-else class="cancel-subscription">
                    <ui-button :iconName="'icon--link-size16'"
                               @click="onMoveCancelSubscription('geo')">{{ $t('common.cancelSubscription') }}</ui-button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </content-box>
        <div class="button--wrap">
          <ui-button class="btn__cancel"
                     @click="onCancelDeactivate">{{ $t('common.cancel') }}</ui-button>
          <ui-button :primary="true"
                     @click="onMoveContactUs">{{ $t('common.contactUs') }}</ui-button>
        </div>
      </template>
    </div>
    <dimmed v-if="useDimmed">
      <deactivate
        v-if="isShowConfirmDeleteLayer"
        @onCloseLayer="isShowConfirmDeleteLayer = false"/>
    </dimmed>
  </div>
</template>

<script>
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import BackToTop from '@/components/ui/BackToTop'
import UiCheckbox from '@/components/ui/UiCheckbox'
import Dimmed from '@/components/ui/Dimmed'
import Deactivate from '@/components/user-info/my-information/Deactivate'
import { deactivateInfo } from '@/api/user'
import { mapState } from 'vuex'
import { getDialog } from '@/libs/vue-utils'
import { getLocaleDateStr, openContactUs, openBaManagePlan, openGeoManagePlan } from '@/libs/utils'
import { getRemainJam } from '@/api/jam'

const openDialog = getDialog('dialogType')

export default {
  name: 'deactivateInfo',
  components: {
    UiLoadingCircle,
    ContentBox,
    UiButton,
    BackToTop,
    UiCheckbox,
    Dimmed,
    Deactivate
  },
  data () {
    return {
      isLoading: true,
      isShowConfirmDeleteLayer: false,
      model: {
        withDrawAgree: false
      },
      modelError: false,
      deactivateInfo: null,
      freePlan: {
        beusable: [0, 100, 101] // Trial, TrialOver, Terminate
      },
      jam: {
        total: 0,
        free: 0,
        paid: 0
      }
    }
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    useDimmed () {
      return this.isShowConfirmDeleteLayer
    },
    beusablePlan () {
      return this.deactivateInfo.beusable
    },
    baPlan () {
      return this.deactivateInfo.ba
    },
    geoPlan () {
      return this.deactivateInfo.geo
    },
    isUsingService () {
      return {
        beusable: !!(this.beusablePlan && this.beusablePlan.current),
        ba: !!(this.baPlan && this.baPlan.current),
        geo: !!(this.geoPlan && this.geoPlan.current)
      }
    },
    canDeactivate () {
      return this.canDeactivateService.beusable && this.canDeactivateService.ba && this.canDeactivateService.geo
    },
    canDeactivateService () {
      return {
        beusable: !this.isUsingService.beusable || this.beusablePlan.current.bFree,
        ba: !this.isUsingService.ba || this.baPlan.current.bFree,
        geo: !this.isUsingService.geo || this.geoPlan.current.bFree
      }
    },
    unusedJam () {
      if (this.jam.total > 0) {
        return 'deactivated'
      } else {
        return 'activated'
      }
    }
  },
  methods: {
    formatEndDate (date) {
      return getLocaleDateStr(date)
    },
    onCancelDeactivate () {
      this.$emit('closeWithdraw')
    },
    onChangeCheckboxValue () {
      this.model.withDrawAgree = !this.model.withDrawAgree
      this.modelError = false
    },
    onMoveContactUs () {
      openContactUs(this.userData)
    },
    onMoveCancelSubscription (service) {
      if (service === 'beusable') {
        this.$router.push({ name: 'managePlan', params: { action: 'cancelPlan' } })
      } else if (service === 'ba') {
        openBaManagePlan()
      } else {
        openGeoManagePlan()
      }
    },
    onShowConfirmDeleteLayer () {
      if (!this.model.withDrawAgree) {
        this.modelError = true
        return false
      }
      this.isShowConfirmDeleteLayer = true
    },
    setRemainJam () {
      const payload = {
        user_id: this.userData.userId,
        user_num: this.userData.userNum
      }
      getRemainJam(payload).then(res => {
        this.jam.total = res.paidCount + res.freeCount
        this.jam.free = res.freeCount
        this.jam.paid = res.paidCount
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.setRemainJam()
    deactivateInfo().then(response => {
      this.deactivateInfo = response
      this.isLoading = false
    }).catch(() => {
      this.isLoading = false
      openDialog('common.error')
    })
  }
}
</script>

<style lang="scss" scoped="scoped">
  .content__body {
  height: calc(100vh - 166px);
  padding-top: 30px;
  overflow-y: auto;
  text-align: center;

  .content__withdraw {
    margin: 0 auto;
    padding: 45px 25px;
    color: #444;
    border: solid 2px #ec0047;

    &.no-deactivate {
      padding-bottom: 27px;

      .title--wrap {
        .title {
          padding: 15px 0;
        }
      }
    }

    &.can-deactivate {
      .title--wrap {
        border-bottom: 1px solid #d8d8d8;
        padding-bottom: 28px;
      }
    }

    .title--wrap {
      width: 700px;
      margin: 0 auto;

      .title {
        font-size: 22px;
        font-weight: 500;
        line-height: 1.45;
      }
      strong {
        display: inline-block;
        margin-top: 14px;
        font-size: 15px;
        font-weight: 500;
        line-height: 1;
        color: $brandColor;
      }

      i {
        margin: 20px 15px 5px 15px;
        vertical-align: middle;

        &.icon--logo-red {
          width: 126px;
          height: 20px;
          background-size: 100% 100%;
        }

        &.icon--logo-bly {
          margin-bottom: 1px;
          width: 126px;
          height: 28px;
          background-size: 100% 100%;
        }
      }
    }

    .desc--wrap {
      padding-top: 50px;
      padding-bottom: 20px;

      p {
        &:nth-of-type(1) {
          font-size: 15px;
          font-weight: 500;
        }
        &:nth-of-type(2) {
          margin-top: 25px;
          margin-bottom: 20px;
          font-size: 14px;
          line-height: 1.43;
        }
      }
    }

    .analytics-page--wrap,
    .current-plan--wrap {
      margin: 0 auto;
      width: 750px;
      border: solid 8px #e6e6e6;
      padding: 26px;
      text-align: left;
      box-sizing: border-box;
      &.center {
        text-align: center;
      }
    }

    .analytics-page--wrap {
      ul {
        margin: -8px 0;
        li {
          margin: 15px 0 15px 113px;

          h5 {
            font-size: 15px;
            color: #ec0047;
            display: inline-block;
            width: 120px;
            position: relative;
            vertical-align: top;

            &:not(.no-bullet)::before {
              position: absolute;
              top: 5px;
              left: -10px;
              content: "";
              width: 4px;
              height: 4px;
              border-radius: 4px;
              background-color: #ec0047;
            }
          }

          p {
            font-size: 14px;
            color: #444444;
            display: inline-block;
            vertical-align: top;
          }
        }
      }
      .unused-jam--wrap {
        padding: 30px 110px 70px 110px;
        text-align: center;
        .description {
          font-size: 14px;
          line-height: 20px;
          color: #ec0047
        }
        .jam-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 50px;
          position: relative;
          .jam {
            display: flex;
            align-items: center;
            span {
                margin-left: 5px;
                color: #444444;
                font-size: 16px;
                font-weight: 600;
              }
          }
          div {
            font-size: 16px;
            font-weight: 400;
            color: #ec0047;
            background-size: contain;
            span {
              color: #444444;
            }
          }
        }
        .jam-info::after {
          content: '';
          width: 100%;
          border: 1px dashed #E6E6E6;
          position: absolute;
          bottom: -10px;
        }
      }
    }

    .current-plan--wrap {
      text-align: center;
      margin-top: 32px;

      & > div {
        @include flexYcenter;
      }

      .desc {
        margin-top: 21px;
        font-size: 14px;
        line-height: 1.43;
        color: #ec0047;
      }

      ul {
        width: 483px;
        margin: 52px auto 10px auto;

        li {
          white-space: nowrap;
          display: flex;
          justify-content: space-between;
          height: 38px;
          align-items: center;
          padding-bottom: 13px;
          margin-bottom: 13px;
          border-bottom: 1px dashed #d7d7d7;

          & > * {
            width: 32.5% !important;
          }

          i {
            width: 35% !important;
            background-position: center left;

            &.icon--logo-horizontal {
              background-size: 169px 22px;
            }

            &.icon--logo-beu {
              background-size: 97px 15px;
            }

            &.icon--logo-bly {
              background-size: 97px 22px;
            }
          }

          .plan-name {
            font-size: 16px;
            font-weight: 500;
            color: #444444;
            width: 70px;
            text-align: center;
            display: inline-block;
            white-space: nowrap;
          }

          .expire-date {
            text-align: center;
            display: inline-block;
            width: 150px;
            font-size: 14px;
            color: #444444;
          }

          .cancel-subscription {
            position: relative;
            height: 38px;
            text-align: center;

            .ui-btn {
              font-size: 13px;
              font-weight: 500;
              color: #444444;
            }
          }
        }
      }
    }

    .chk-box--wrap {
      position: relative;
      margin-top: 30px;
      margin-bottom: 20px;

      .validation-text {
        @include validErrorText;
        position: absolute;
        left: 50%;
        bottom: -20px;
        transform: translateX(-50%);
      }
    }
  }

  .button--wrap {
    margin-top: 30px;
    margin-bottom: 127px;
    text-align: center;

    .ui-btn {
      padding: 0 30px;

      &.btn__cancel {
        margin-right: 5px;
      }
    }
  }

  &.loading-enter-active,
  &.loading-leave-active {
    transition: opacity 0.3s ease;
  }

  &.loading-enter,
  &.loading-leave-to{
    opacity: 0;
  }
}
</style>
